import { ReactElement } from 'react'
import { t } from 'i18next'
import { ContentLoader, Grid, ServiceCard } from '@raskrask-dk/rr-components'
import { Props, StyledBasisTypeCards } from '.'

const BasisTypeCardsTemplate = ({
    basisTypes,
    onBasisTypeClick,
    isLoading,
    customerType,
}: Props): ReactElement => {
    const loadingArray = Array.from(Array(3).keys())

    const initialLoading = loadingArray.map((_num, key) => (
        <ContentLoader key={key} component="ServiceCard" />
    ))

    const chooseBasisTypeText = t('common:choose')

    const basisTypesCards = [...basisTypes].map((basisType, key) => (
        <ServiceCard
            buttonText={chooseBasisTypeText}
            data-cy={`BasisType_${key + 1}`}
            disabled={basisType.disabled}
            icon={basisType.icon}
            key={key}
            name={t(`common:basistypes.${basisType.id}.name`)}
            onClick={() => onBasisTypeClick(basisType)}
            text={t(
                customerType == 'Company' && basisType.id == 1
                    ? `common:basistypes.company.${basisType.id}.subtext`
                    : `common:basistypes.${basisType.id}.subtext`
            )}
        />
    ))

    return (
        <StyledBasisTypeCards>
            <Grid
                autoFlow={{
                    '@mobile': 'row',
                    '@desktop': 'dense',
                }}
                gap={{ '@mobile': 16, '@desktop': 32 }}
            >
                {isLoading ? initialLoading : basisTypesCards}
            </Grid>
        </StyledBasisTypeCards>
    )
}

export default BasisTypeCardsTemplate
